import { render } from "./TestAddedCover.vue?vue&type=template&id=56fd41f6&scoped=true"
const script = {}

import "./TestAddedCover.vue?vue&type=style&index=0&id=56fd41f6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fd41f6"]])

export default __exports__